import { render, staticRenderFns } from "./RobinButton.vue?vue&type=template&id=75623826&"
import script from "./RobinButton.vue?vue&type=script&lang=js&"
export * from "./RobinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports